import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoIcon from '../components/assets/icon.png';
import Footer from '../components/Footer';
import EnquiryModal from '../components/EnquiryModal';
import '../App.css';

const ShortMovies = () => {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="service-page">
      {/* Header */}
      <nav className="navbar scrolled">
        <div className="container nav-content">
          <Link to="/" className="logo">
            <img src={logoIcon} alt="Magic Moon Studios" className="logo-icon-img" />
            <span className="logo-text">MAGIC MOON STUDIOS</span>
          </Link>

          <button 
            className="mobile-menu-btn" 
            onClick={(e) => {
              e.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
              setIsDropdownOpen(false);
              document.body.style.overflow = isMenuOpen ? 'unset' : 'hidden';
            }}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          {isMenuOpen && (
            <div 
              className="mobile-menu-backdrop" 
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(false);
                setIsDropdownOpen(false);
                document.body.style.overflow = 'unset';
              }}
            />
          )}

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={handleMenuClick}>Home</Link></li>
            <li><a href="/#about" onClick={handleMenuClick}>About</a></li>
            <li><a href="/#projects" onClick={handleMenuClick}>Projects</a></li>
            <li className={`dropdown ${isDropdownOpen ? 'active' : ''}`}>
              <a href="#services" onClick={toggleDropdown}>Services ▾</a>
              <ul className="dropdown-menu">
                <li><Link to="/film-production" onClick={handleMenuClick}>Film Production</Link></li>
                <li><Link to="/short-movies" onClick={handleMenuClick}>Short Movies</Link></li>
                <li><Link to="/academy" onClick={handleMenuClick}>Academy</Link></li>
                <li><Link to="/ads-making" onClick={handleMenuClick}>Ads Making</Link></li>
                <li><Link to="/digital-content" onClick={handleMenuClick}>Digital Content</Link></li>
                <li><Link to="/music-production" onClick={handleMenuClick}>Music Production</Link></li>
              </ul>
            </li>
            <li><a href="/#team" onClick={handleMenuClick}>Team</a></li>
            <li><a href="/#contact" className="contact-btn" onClick={handleMenuClick}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="service-hero" style={{ 
        background: 'linear-gradient(rgba(15, 52, 96, 0.85), rgba(26, 26, 46, 0.85)), url("https://images.unsplash.com/photo-1574267432644-f74f8c95df28?q=80&w=2000&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container">
          <div className="service-hero-content">
            <h1 className="service-hero-title">Short Movies</h1>
            <p className="service-hero-subtitle">
              Compelling short films and web series for digital platforms and festivals
            </p>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-image">
              <img 
                src="https://images.unsplash.com/photo-1536440136628-849c177e76a1?q=80&w=800&auto=format&fit=crop" 
                alt="Short Movies Production"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '15px',
                  border: '3px solid #B8860B',
                  boxShadow: '0 10px 30px rgba(184, 134, 11, 0.3)'
                }}
              />
            </div>
            <div className="overview-content">
              <h2 style={{ color: '#5B9BD5', marginBottom: '20px' }}>Short-Form Storytelling</h2>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Short films are the perfect medium for powerful storytelling. Whether it's a 5-minute web series episode 
                or a 30-minute festival submission, we create content that captivates audiences and leaves lasting impressions.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Our short movie production services include concept development, scriptwriting, production, post-production, 
                and distribution strategy for digital platforms like YouTube, Instagram, and film festivals worldwide.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Create */}
      <section className="service-offerings" style={{ background: 'linear-gradient(to bottom, #F0F9FF 0%, #E3F2FD 100%)', padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#5B9BD5', marginBottom: '50px', fontSize: '2.5rem' }}>What We Create</h2>
          <div className="offerings-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {[
              { title: 'Web Series', desc: 'Episodic content for YouTube, social media, and streaming platforms', icon: '📱' },
              { title: 'Festival Films', desc: 'Award-worthy short films for national and international festivals', icon: '🏆' },
              { title: 'Brand Stories', desc: 'Narrative-driven brand content that connects with audiences', icon: '🎬' },
              { title: 'Experimental', desc: 'Artistic and avant-garde films pushing creative boundaries', icon: '🎨' }
            ].map((service, index) => (
              <div key={index} style={{
                background: '#fff',
                padding: '30px',
                borderRadius: '15px',
                border: '2px solid #B8860B',
                textAlign: 'center',
                boxShadow: '0 5px 20px rgba(91, 155, 213, 0.15)'
              }}>
                <div style={{ fontSize: '4rem', marginBottom: '15px' }}>{service.icon}</div>
                <h3 style={{ color: '#FFD700', marginBottom: '10px' }}>{service.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Timeline */}
      <section style={{ padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#5B9BD5', marginBottom: '50px', fontSize: '2.5rem' }}>Our Process</h2>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {[
              { step: '1', title: 'Concept & Script', desc: 'We develop your idea into a compelling screenplay' },
              { step: '2', title: 'Pre-Production', desc: 'Casting, location scouting, and production planning' },
              { step: '3', title: 'Production', desc: 'Professional filming with cinema-grade equipment' },
              { step: '4', title: 'Post-Production', desc: 'Editing, color grading, sound design, and VFX' },
              { step: '5', title: 'Distribution', desc: 'Festival submissions and digital platform releases' }
            ].map((process, index) => (
              <div key={index} style={{
                display: 'flex',
                gap: '20px',
                marginBottom: '30px',
                padding: '20px',
                background: 'linear-gradient(135deg, rgba(91, 155, 213, 0.1) 0%, rgba(135, 206, 235, 0.05) 100%)',
                borderRadius: '10px',
                border: '2px solid #B8860B'
              }}>
                <div style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#1a1a2e',
                  fontWeight: '900',
                  fontSize: '1.5rem',
                  flexShrink: 0
                }}>
                  {process.step}
                </div>
                <div>
                  <h3 style={{ color: '#5B9BD5', marginBottom: '5px' }}>{process.title}</h3>
                  <p style={{ color: '#666', margin: 0 }}>{process.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta" style={{ 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', 
        padding: '80px 0',
        textAlign: 'center',
        color: '#fff'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#FFD700' }}>Let's Create Your Short Film</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', color: '#87CEEB' }}>
            Transform your story into a powerful short film
          </p>
          <button onClick={() => setIsEnquiryOpen(true)} style={{
            display: 'inline-block',
            padding: '15px 40px',
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            color: '#1a1a2e',
            borderRadius: '30px',
            fontWeight: '700',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem'
          }}>
            Start Your Project
          </button>
        </div>
      </section>

      {/* Enquiry Modal */}
      <EnquiryModal 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
        serviceName="Short Movies"
      />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default ShortMovies;
